import { SalesforceGetObjectsConfig } from 'ihub/common';
import { AdvancedTourStep } from '../shared-types';
import { TaskTourProps } from './task-tour-props';

export function getSalesforceGetObjectsTourSteps({
	defaultStyles,
	microTaskConfigType,
}: Readonly<TaskTourProps>): AdvancedTourStep[] {
	if (!microTaskConfigType) return [];
	const config = microTaskConfigType as SalesforceGetObjectsConfig;

	return [
		{
			id: 'client-id',
			selector: '[data-tour="client-id"]',
			content:
				'Required: The Salesforce client id. Note that this value is populated via a Flow Parameter of type Passphrase properties',
		},
		{
			id: 'client-secret',
			selector: '[data-tour="client-secret"]',
			content:
				'Required: The Salesforce client secret. Note that this value is populated via a Flow Parameter of type Passphrase properties',
		},
		{
			id: 'instance-url',
			selector: '[data-tour="instance-url"]',
			content:
				'Required: The Salesforce instance URL. Note that this property supports expressions. Please see Expression Selector for more information.',
		},
		{
			id: 'object-type',
			selector: '[data-tour="object-type"]',
			content:
				'Required: The list of supported object types supported by the connected Salesforce instance. Note that this dropdown will only populate once valid connection details have been provided.',
		},
		{
			id: 'batch-start',
			selector: '[data-tour="batch-start"]',
			content:
				'Required: The index at which the request will start returning data based on the provided filters. By using an variable via an expression it is possible to create a recursive flow that will fetch data in batches until completion.',
		},
		{
			id: 'batch-size',
			selector: '[data-tour="batch-size"]',
			content: 'Required: The amount of records that should be retrieved at a time.',
		},
		{
			id: 'batch-done',
			selector: '[data-tour="batch-done"]',
			content:
				'A variable name that will be used if the retrieved batch is the last available batch.',
		},
		{
			id: 'select-fields',
			selector: '[data-tour="select-fields"]',
			content:
				'The collection of fields that will be selected from the selected object type. If no fields are specifically selected the entire object will be retrieved.',
		},
		{
			id: 'add-select',
			selector: '[data-tour="add-select"]',
			content:
				'Adds a configuration item that will specify a field to select. Note the dropdown list will be populated based on the selected field.',
		},
		...(config.fields.length > 0
			? [
					{
						id: 'remove-select',
						selector: '[data-tour="remove-select"]',
						content: 'Remove a property from the select fields.',
					},
				]
			: []),

		{
			id: 'where-fields',
			selector: '[data-tour="where-fields"]',
			content:
				'The collection of rules that will be used to filter the data being fetched. Note this section uses the Rule Builder to configure this filter.',
		},
		{
			id: 'sort-fields',
			selector: '[data-tour="sort-fields"]',
			content: 'The fields that should be used to order the result data.',
		},
		{
			id: 'add-sort-field',
			selector: '[data-tour="add-sort-field"]',
			content: 'Add a field to the collection of sort field.',
		},
	].map(tourItem => ({ ...tourItem, styles: defaultStyles }));
}
